import { axios } from '@/utils/request'

// 预加载
export function getGoodsPre(parameter) {
  return axios({
    url: '/merchant.php/goods/pre/',
    method: 'get',
    params: parameter
  })
}

// 商品管理 - 商品列表
export function getGoodsList(parameter) {
  return axios({
    url: '/merchant.php/goods/getList',
    method: 'get',
    params: parameter
  })
}

// 商品管理 - 商品详情
export function getGoodsDetail(parameter) {
  return axios({
    url: '/merchant.php/Goods/detail',
    method: 'get',
    params: parameter
  })
}

// 商品管理 - 新增商品
export function postGoodsAdd(data) {
  return axios({
    url: '/merchant.php/Goods/add',
    method: 'post',
    data: data
  })
}

// 商品管理 - 编辑商品
export function postGoodsEdit(data) {
  return axios({
    url: '/merchant.php/Goods/edit',
    method: 'post',
    data: data
  })
}

// 商品管理 - 删除商品
export function postGoodsDel(data) {
  return axios({
    url: '/merchant.php/Goods/del',
    method: 'post',
    data: data
  })
}

// 商品管理 - 商品分类列表
export function getGoodsCategoryList(parameter) {
  return axios({
    url: '/merchant.php/goods/getCategoryList',
    method: 'get',
    params: parameter
  })
}

// 商品管理 - 商品分类详情
export function getGoodsCategoryDetail(parameter) {
  return axios({
    url: '/merchant.php/Goods/categoryDetail',
    method: 'get',
    params: parameter
  })
}

// 商品管理 - 新增商品分类
export function postGoodsCategoryAdd(data) {
  return axios({
    url: '/merchant.php/Goods/addCategory',
    method: 'post',
    data: data
  })
}

// 商品管理 - 编辑商品分类
export function postGoodsCategoryEdit(data) {
  return axios({
    url: '/merchant.php/Goods/editCategory',
    method: 'post',
    data: data
  })
}

// 商品管理 - 删除商品分类
export function postGoodsCategoryDel(data) {
  return axios({
    url: '/merchant.php/Goods/delCategory',
    method: 'post',
    data: data
  })
}

// 商品复制
export function postCopyGoods(data) {
  return axios({
    url: '/merchant.php/Goods/copyGoods',
    method: 'post',
    data: data
  })
}
